import React from 'react';
import { GenericView, SearchInput, ActionButtons } from '../../../components/common/table';

const SalesByServiceItem = ({
    salesByServiceData,
    metrics,
    isLoading,
    searchQueryServiceItem,
    setSearchQueryServiceItem,
    handleExportExcelServiceItem,
    formatCurrencyValue
}) => {
    // Filter data by search query
    const filteredServiceItemData = salesByServiceData.filter(item => {
        if (!searchQueryServiceItem) return true;
        const query = searchQueryServiceItem.toLowerCase();
        return (
            item.serviceItem?.toLowerCase().includes(query) ||
            item.standard?.toLowerCase().includes(query)
        );
    });

    // Table columns configuration
    const serviceItemColumns = [
        {
            key: 'serviceItem',
            label: 'SERVICE ITEMS',
            className: 'text-truncate',
            sortValue: (item) => item.serviceItem || '',
            render: (serviceItem, row) => {
                const isTotal = serviceItem === 'GRAND TOTAL';
                return (
                    <span
                        className={`text-truncate d-inline-block ${isTotal ? 'fw-bold' : ''}`}
                        style={{ maxWidth: '200px', width: '200px' }}
                        title={serviceItem}
                    >
                        {serviceItem || '-'}
                    </span>
                );
            },
            sortable: true
        },
        {
            key: 'standard',
            label: 'STANDARD',
            className: 'text-truncate',
            sortValue: (item) => item.standard || '',
            render: (standard, row) => {
                const isTotal = row.serviceItem === 'GRAND TOTAL';
                return (
                    <span
                        className={`text-truncate d-inline-block ${isTotal ? 'fw-bold' : ''}`}
                        style={{ maxWidth: '200px', width: '200px' }}
                        title={standard}
                    >
                        {isTotal ? '' : (standard || '-')}
                    </span>
                );
            },
            sortable: true
        },
        {
            key: 'qtyTerjual',
            label: 'QTY. TERJUAL',
            className: 'text-truncate',
            sortValue: (item) => item.qtyTerjual || 0,
            render: (qty, row) => {
                const isTotal = row.serviceItem === 'GRAND TOTAL';
                return (
                    <span
                        className={`text-truncate d-inline-block ${isTotal ? 'fw-bold' : ''}`}
                        style={{ textAlign: 'right', maxWidth: '120px', width: '120px' }}
                        title={qty}
                    >
                        {isTotal ? '' : (qty || 0)}
                    </span>
                );
            },
            sortable: true
        },
        {
            key: 'totalRevenue',
            label: 'TOTAL REVENUE',
            className: 'text-truncate',
            sortValue: (item) => item.totalRevenue || 0,
            render: (revenue, row) => {
                const isTotal = row.serviceItem === 'GRAND TOTAL';
                const formattedValue = `Rp ${formatCurrencyValue(revenue || 0)}`;
                return (
                    <span
                        className={`text-truncate d-inline-block ${isTotal ? 'fw-bold' : ''}`}
                        style={{ textAlign: 'right', maxWidth: '180px', width: '180px' }}
                        title={formattedValue}
                    >
                        {formattedValue}
                    </span>
                );
            },
            sortable: true
        },
        {
            key: 'totalMandays',
            label: 'TOTAL MANDAYS',
            className: 'text-truncate',
            sortValue: (item) => item.totalMandays || 0,
            render: (mandays, row) => {
                const isTotal = row.serviceItem === 'GRAND TOTAL';
                return (
                    <span
                        className={`text-truncate d-inline-block ${isTotal ? 'fw-bold' : ''}`}
                        style={{ textAlign: 'right', maxWidth: '120px', width: '120px' }}
                        title={mandays}
                    >
                        {isTotal ? '' : (mandays || 0)}
                    </span>
                );
            },
            sortable: true
        },
        {
            key: 'avgRateManday',
            label: 'AVG. RATE/MANDAY',
            className: 'text-truncate',
            sortValue: (item) => item.avgRateManday || 0,
            render: (avgRate, row) => {
                const isTotal = row.serviceItem === 'GRAND TOTAL';
                const formattedValue = isTotal ? '' : `Rp ${formatCurrencyValue(avgRate || 0)}`;
                return (
                    <span
                        className={`text-truncate d-inline-block ${isTotal ? 'fw-bold' : ''}`}
                        style={{ textAlign: 'right', maxWidth: '180px', width: '180px' }}
                        title={formattedValue}
                    >
                        {formattedValue}
                    </span>
                );
            },
            sortable: true
        }
    ];

    return (
        <>
            {/* Metrics Summary Section */}
            <h3 className="mb-3">Sales Analysis per Service Item</h3>
            <div className="row mb-4">
                <div className="col-md-2">
                    <div className="card h-100">
                        <div className="card-status-start bg-cyan"></div>
                        <div className="card-body d-flex flex-column">
                            <div className="flex-fill">
                                <div className="text-muted mb-2">Total Mandays Sold</div>
                                <div className="h3 mb-0">{metrics.totalMandays || 0}</div>
                                <div className="h3 text-cyan">{metrics.invoiceCount || 0} Invoice</div>
                            </div>
                            <div className="text-muted small">Total number of workday capacity sold.</div>
                        </div>
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="card h-100">
                        <div className="card-status-start bg-blue"></div>
                        <div className="card-body d-flex flex-column">
                            <div className="flex-fill">
                                <div className="text-muted mb-2">Average Rate per Manday</div>
                                <div className="h3 mb-0">Rp {formatCurrencyValue(metrics.avgRateManday || 0)}</div>
                                <div className="h3 text-blue">{metrics.totalMandays || 0} MDs</div>
                            </div>
                            <div className="text-muted small">Average price paid per service workday (global).</div>
                        </div>
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="card h-100">
                        <div className="card-status-start bg-primary"></div>
                        <div className="card-body d-flex flex-column">
                            <div className="flex-fill">
                                <div className="text-muted mb-2">Rate/MD: Certification</div>
                                <div className="h3 mb-0">Rp {formatCurrencyValue(metrics.rateCertification || 0)}</div>
                                <div className="h3 text-primary">{metrics.mandaysCertification || 0} MDs</div>
                            </div>
                            <div className="text-muted small">Average Rate/MD for the Certification category.</div>
                        </div>
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="card h-100">
                        <div className="card-status-start bg-lime"></div>
                        <div className="card-body d-flex flex-column">
                            <div className="flex-fill">
                                <div className="text-muted mb-2">Rate/MD: IT Audit</div>
                                <div className="h3 mb-0">Rp {formatCurrencyValue(metrics.rateITAudit || 0)}</div>
                                <div className="h3 text-lime">{metrics.mandaysITAudit || 0} MDs</div>
                            </div>
                            <div className="text-muted small">Average Rate/MD for the IT Audit category.</div>
                        </div>
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="card h-100">
                        <div className="card-status-start bg-success"></div>
                        <div className="card-body d-flex flex-column">
                            <div className="flex-fill">
                                <div className="text-muted mb-2">Rate/MD: Sustainability</div>
                                <div className="h3 mb-0">Rp {formatCurrencyValue(metrics.rateSustainability || 0)}</div>
                                <div className="h3 text-success">{metrics.mandaysSustainability || 0} MDs</div>
                            </div>
                            <div className="text-muted small">Average Rate/MD for the Sustainability category.</div>
                        </div>
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="card h-100">
                        <div className="card-status-start bg-purple"></div>
                        <div className="card-body d-flex flex-column">
                            <div className="flex-fill">
                                <div className="text-muted mb-2">Rate/MD: Training</div>
                                <div className="h3 mb-0">Rp {formatCurrencyValue(metrics.rateTraining || 0)}</div>
                                <div className="h3 text-purple">{metrics.mandaysTraining || 0} MDs</div>
                            </div>
                            <div className="text-muted small">Average Rate/MD for the Training category.</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* List Data Section */}
            <div className="card">
                <div className="card-header">
                    <ul className="nav nav-tabs card-header-tabs" data-bs-toggle="tabs" role="tablist">
                        <li className="nav-item-tab" role="presentation">
                            <a href="#tabs-list-data-service" className="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab">List Data</a>
                        </li>
                    </ul>
                </div>
                <div className="card-body">
                    <div className="tab-content">
                        <div className="tab-pane active show" id="tabs-list-data-service" role="tabpanel">
                            <GenericView
                                data={filteredServiceItemData}
                                columns={serviceItemColumns}
                                isLoading={isLoading}
                                emptyStateMessage="No sales by service item data found"
                                searchComponent={
                                    <SearchInput
                                        value={searchQueryServiceItem}
                                        onChange={setSearchQueryServiceItem}
                                        placeholder="Search service item or standard..."
                                    />
                                }
                                actionButtons={
                                    <ActionButtons
                                        onExportExcel={handleExportExcelServiceItem}
                                    />
                                }
                                rowClassName={(row) => {
                                    return row.serviceItem === 'GRAND TOTAL' ? 'table-active fw-bold' : '';
                                }}
                                isRowSelectable={(row) => {
                                    return row.serviceItem !== 'GRAND TOTAL';
                                }}
                                showPagination={true}
                                initialPageSize={10}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SalesByServiceItem;
